import "core-js/modules/es.date.now.js";
import { intlDate } from "@faire/web/common/localization/date-fns/intlDate";
import differenceInDays from "date-fns/differenceInDays";
import { additionalDataRequiredForFaireDiscountsSignUpOfferIA } from "../../shared/instantAnswerUtils";
import { ViewOfferDetailsCTA } from "./ctas";
export var WhenDoesSignupExpireIA = function WhenDoesSignupExpireIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      var _context$faireDirectD;
      return getAnswer(strictLocalize, (_context$faireDirectD = context.faireDirectDiscountsContext) === null || _context$faireDirectD === void 0 ? void 0 : _context$faireDirectD.discounts).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      var _context$faireDirectD2;
      return getAnswer(strictLocalize, (_context$faireDirectD2 = context.faireDirectDiscountsContext) === null || _context$faireDirectD2 === void 0 ? void 0 : _context$faireDirectD2.discounts).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    },
    additionalRequiredData: additionalDataRequiredForFaireDiscountsSignUpOfferIA()
  };
};
var getAnswer = function getAnswer(strictLocalize, discounts) {
  if (discounts && discounts[0]) {
    if (discounts.length > 1) {
      return GENERAL_FAIRE_DIRECT_ANSWER(strictLocalize);
    } else if (discounts[0].is_expired) {
      return RELATIONSHIP_EXPIRED_ANSWER(strictLocalize, discounts[0]);
    } else {
      return RELATIONSHIP_NOT_EXPIRED_ANSWER(strictLocalize, discounts[0]);
    }
  } else {
    return NO_RELATIONSHIPS_ANSWER(strictLocalize);
  }
};
var getPrimaryCTA = function getPrimaryCTA(context, strictLocalize) {
  var _context$faireDirectD3;
  var discounts = (_context$faireDirectD3 = context.faireDirectDiscountsContext) === null || _context$faireDirectD3 === void 0 ? void 0 : _context$faireDirectD3.discounts;
  if ((discounts === null || discounts === void 0 ? void 0 : discounts.length) === 1 && discounts[0]) {
    return ViewOfferDetailsCTA(strictLocalize);
  }
  return undefined;
};
var GENERAL_FAIRE_DIRECT_ANSWER = function GENERAL_FAIRE_DIRECT_ANSWER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return GENERAL_FAIRE_DIRECT_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [GENERAL_FAIRE_DIRECT_DESCRIPTION(strictLocalize)];
    }
  };
};
var GENERAL_FAIRE_DIRECT_TITLE = function GENERAL_FAIRE_DIRECT_TITLE(strictLocalize) {
  return strictLocalize({
    id: "lKxnlX",
    defaultMessage: [{
      "type": 0,
      "value": "How does the sign-up offer work"
    }]
  });
};
var GENERAL_FAIRE_DIRECT_DESCRIPTION = function GENERAL_FAIRE_DIRECT_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "x52u0e",
    defaultMessage: [{
      "type": 0,
      "value": "When you join Faire using a brand’s link, you’ll receive a sign-up offer, including a promotion and one year of free shipping with that brand. The offer is automatically applied at checkout and expires 7 days after signing up."
    }]
  });
};
var RELATIONSHIP_EXPIRED_ANSWER = function RELATIONSHIP_EXPIRED_ANSWER(strictLocalize, relationship) {
  return {
    getTitle: function getTitle() {
      return RELATIONSHIP_EXPIRED_TITLE(strictLocalize, relationship);
    },
    getDescription: function getDescription() {
      return [RELATIONSHIP_EXPIRED_DESCRIPTION(strictLocalize, relationship)];
    }
  };
};
var RELATIONSHIP_EXPIRED_TITLE = function RELATIONSHIP_EXPIRED_TITLE(strictLocalize, relationship) {
  return strictLocalize({
    id: "DKizqc",
    defaultMessage: [{
      "type": 0,
      "value": "Your sign-up offer expired on "
    }, {
      "type": 1,
      "value": "expiryDate"
    }]
  }, {
    expiryDate: intlDate(relationship.expires_at, "PP")
  });
};
var RELATIONSHIP_EXPIRED_DESCRIPTION = function RELATIONSHIP_EXPIRED_DESCRIPTION(strictLocalize, relationship) {
  return strictLocalize({
    id: "ShQ9kz",
    defaultMessage: [{
      "type": 0,
      "value": "Looks like you didn’t place an order with "
    }, {
      "type": 1,
      "value": "brandCompanyName"
    }, {
      "type": 0,
      "value": " before your sign-up offer expired."
    }]
  }, {
    brandCompanyName: relationship.brand_name
  });
};
var RELATIONSHIP_NOT_EXPIRED_ANSWER = function RELATIONSHIP_NOT_EXPIRED_ANSWER(strictLocalize, relationship) {
  return {
    getTitle: function getTitle() {
      return differenceInDays(relationship.expires_at, Date.now()) === 1 ? RELATIONSHIP_NOT_EXPIRED_TITLE_SINGLE_DAY(strictLocalize) : RELATIONSHIP_NOT_EXPIRED_TITLE(strictLocalize, relationship);
    },
    getDescription: function getDescription() {
      return [RELATIONSHIP_NOT_EXPIRED_DESCRIPTION(strictLocalize, relationship)];
    }
  };
};
var RELATIONSHIP_NOT_EXPIRED_TITLE = function RELATIONSHIP_NOT_EXPIRED_TITLE(strictLocalize, relationship) {
  return strictLocalize({
    id: "zx7KJt",
    defaultMessage: [{
      "type": 0,
      "value": "You have "
    }, {
      "type": 1,
      "value": "daysLeftNumber"
    }, {
      "type": 0,
      "value": " days left to use your sign-up offer"
    }]
  }, {
    daysLeftNumber: differenceInDays(relationship.expires_at, Date.now())
  });
};
var RELATIONSHIP_NOT_EXPIRED_TITLE_SINGLE_DAY = function RELATIONSHIP_NOT_EXPIRED_TITLE_SINGLE_DAY(strictLocalize) {
  return strictLocalize({
    id: "f98ytK",
    defaultMessage: [{
      "type": 0,
      "value": "You have 1 day left to use your sign-up offer"
    }]
  });
};
var RELATIONSHIP_NOT_EXPIRED_DESCRIPTION = function RELATIONSHIP_NOT_EXPIRED_DESCRIPTION(strictLocalize, relationship) {
  return strictLocalize({
    id: "WB3xVz",
    defaultMessage: [{
      "type": 0,
      "value": "When you place your first order with "
    }, {
      "type": 1,
      "value": "brandCompanyName"
    }, {
      "type": 0,
      "value": ", the sign-up offer will automatically be applied at checkout. Note that the offer expires on "
    }, {
      "type": 1,
      "value": "expiryDate"
    }, {
      "type": 0,
      "value": "."
    }]
  }, {
    brandCompanyName: relationship.brand_name,
    expiryDate: intlDate(relationship.expires_at, "PP")
  });
};
var NO_RELATIONSHIPS_ANSWER = function NO_RELATIONSHIPS_ANSWER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return NO_RELATIONSHIPS_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [NO_RELATIONSHIPS_DESCRIPTION(strictLocalize)];
    }
  };
};
var NO_RELATIONSHIPS_TITLE = function NO_RELATIONSHIPS_TITLE(strictLocalize) {
  return strictLocalize({
    id: "iKLc4x",
    defaultMessage: [{
      "type": 0,
      "value": "You don’t qualify for the Faire Direct offer"
    }]
  });
};
var NO_RELATIONSHIPS_DESCRIPTION = function NO_RELATIONSHIPS_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "rWalf9",
    defaultMessage: [{
      "type": 0,
      "value": "The offer is only available to retailers who signed up for a Faire account using a brand’s link."
    }]
  });
};